import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col, Form, CheckboxOptionType } from 'antd';

import { LoadingSkeleton } from './LoadingSkeleton';
import { Paragraph, Title } from '@/components/Typography';
import { useWorkerSelfEvaluations } from '@/hooks/v1/useWorkerSelfEvaluation';
import { usePersonalisedReportContext } from '@/components/views/PersonalisedReports/PersonalisedReport/context';
import { CustomRadioGroup } from './styles';

export const WorkerSelfEvaluation: React.FC = () => {
	const { organization_id, company_id } = usePersonalisedReportContext();
	const {
		data: workerSelfEvaluations,
		isLoading,
		isFetching,
		isError
	} = useWorkerSelfEvaluations({
		organization_id,
		company_id
	});

	if (isLoading || isFetching) {
		return <LoadingSkeleton />;
	}

	const options: CheckboxOptionType[] = workerSelfEvaluations.map(({ id, description }) => ({
		value: id,
		label: I18n.get(description)
	}));

	return (
		<Row justify="start">
			<Col span={24}>
				<Title level={5}>Self-evaluation</Title>
			</Col>
			<Col span={24}>
				<Paragraph>What is the level of stress perceived by the worker when performing the task?</Paragraph>
			</Col>
			<Form.Item
				name={['characteristics', 'worker_self_evaluation_id']}
				rules={[
					{
						required: true,
						message: 'Select a self evaluation'
					}
				]}
			>
				<CustomRadioGroup disabled={isError} options={options} />
			</Form.Item>
		</Row>
	);
};
